// 2026 리디자인: 로고 색(네이비 #363476 · 블루 #0165AC)에서 뽑은 팔레트.
// 기존 키(dark, medium, foreground.* 등)는 그대로 두고 값만 바꿔 사이트 전체 톤을 맞춘다.
const theme = {
  colors: {
    dark: "#14245C",
    littledark: "#1E3172",
    medium: "#2C4A8C",
    light: "#8CA3D0",
    extralight: "#F3F6FB",
    safe: "#0F7B4F",
    caution: "#C2410C",
    // 새 토큰
    ink: "#0B163D",
    accent: "#0165AC",
    accentHover: "#0B7FCF",
    accentSoft: "#E7F1FA",
    line: "#E3E8F0",
    foreground: {
      highlight: "#14245C",
      highlight2: "#0165AC",
      inverted: "white",
      highlightinverted: "#9FCBF2",
      normal: "#151B2C",
      dimmed: "#5B6476",
    },
    monotone: {
      dark: "#2B3243",
      medium: "#8A93A5",
      light: "#DDE3EC",
      extralight: "#F5F7FA",
    },
    background: {
      dark: "#14245C",
      medium: "#2C4A8C",
      light: "#8CA3D0",
      extralight: "#F3F6FB",
      default: "white",
      lightyellow: "#FFFBEB",
      lightgreen: "#ECFDF3",
    },
    pages: {
      branches: {
        background: "#F5F7FA",
      },
      prizes: {
        background: "#F5F7FA",
      },
      history: {
        background: "#F5F7FA",
        navigationBackground: "#EDF1F7",
      },
      esg: {
        background: "#F5F7FA",
      },
    },
  },
  layout: {
    header: "5rem",
    content: "75rem",
  },
  radius: "0.875rem",
  shadow: {
    sm: "0 1px 2px rgba(20, 36, 92, 0.06), 0 2px 8px rgba(20, 36, 92, 0.06)",
    md: "0 2px 4px rgba(20, 36, 92, 0.05), 0 12px 32px rgba(20, 36, 92, 0.10)",
  },
};
export default theme;
